import { useI18N } from '../../libraries/i18n/hook'
import PageHeading from '../components/layout/PageHeading'
import BookmarkedContent from '../containers/users/BookmarkedContent'

const UserBookmarksPage = () => {
  const { t } = useI18N()
  return (
    <>
      <PageHeading>{t('menu.bookmarks')}</PageHeading>
      <BookmarkedContent />
    </>
  )
}

export default UserBookmarksPage
